
import { getCompositionParts, getTechnicalValues } from './values'

const compositionSectionCompareGreaterOrEqual = (type, item, value) => {
  const search = value.split('-')
  const parts = getCompositionParts(item, type)
  for (let i = 0; i < parts.length; i++) {
    if (parts[i].value === value) return true // direct match
    const subject = String(parts[i].value).split('-')
    if (subject.length === 2 &&
      search[0] === subject[0] &&
      Number(search[1]) <= Number(subject[1])) return true
  }
  return false
}

const compositionCompareGreaterOrEqual = (type, item, value) => {
  const parts = getCompositionParts(item, type)
  if (value === null) {
    return parts.length <= 0
  } else {
    for (let i = 0; i < parts.length; i++) {
      if (parts[i].value >= value) {
        return true
      }
    }
  }
  return false
}

const technicalValueCompareEqual = (type, item, value) => {
  const values = getTechnicalValues(item, type)
  return values.length > 0 && values[0] === value
}

const technicalValueCompareGreaterOrEqual = (type, item, value) => {
  const values = getTechnicalValues(item, type)
  return values.length > 0 && values[0] >= value
}

const technicalValueCompareSmallerOrEqual = (type, item, value) => {
  const values = getTechnicalValues(item, type)
  return values.length > 0 && values[0] <= value
}

export default {

  fill: (item, value) => compositionSectionCompareGreaterOrEqual('fill', item, value),

  fireResistance: (item, value) => technicalValueCompareEqual('fireResistance', item, value),

  heatTransferCoefficient: (item, value) => technicalValueCompareSmallerOrEqual('heatTransferCoefficient', item, value),

  impactSoundLevel: (item, value) => technicalValueCompareSmallerOrEqual('impactSoundLevel', item, value),

  insulation: (item, value) => compositionSectionCompareGreaterOrEqual('insulation', item, value),

  screed: (item, value) => compositionSectionCompareGreaterOrEqual('screed', item, value),

  soundReductionIndex: (item, value) => technicalValueCompareGreaterOrEqual('soundReductionIndex', item, value),

  supportingStructure (item, value) { // values : [ 'b-220', 'bs-220', 'bo-120', 'bo-140' ]
    const parts = getCompositionParts(item, 'supportingStructure')

    for (let i = 0; i < parts.length; i++) {
      if (parts[i].value === value) return true // direct match
      if (parts[i].value === 'bs-220' && value === 'b-220') return true // b vs bs match

      const search = String(value).split('-')
      const subject = String(parts[i].value).split('-')

      // if (search.length === 2 && subject.length === 2) {
      //   if (search[0] === 'bo' &&
      //     subject[0] === 'bo' &&
      //     Number(search[1]) <= Number(subject[1])) {
      //     return true
      //   }
      // }
    }

    return false
  },

  suspendedCeiling: (item, value) => {
    if (value === null) return getCompositionParts(item, 'suspendedCeiling').length === 0
    else return compositionSectionCompareGreaterOrEqual('suspendedCeiling', item, value)
  },

  underfloorHeating: (item, value) => {
    if (value === null) return getCompositionParts(item, 'underfloorHeating').length === 0
    else return compositionSectionCompareGreaterOrEqual('underfloorHeating', item, value)
  },

  soundInsulation: (item, value) => {
    if (value === null) return getCompositionParts(item, 'soundInsulation').length === 0
    else return compositionSectionCompareGreaterOrEqual('soundInsulation', item, value)
  },

  woodenPanel: (item, value) => compositionCompareGreaterOrEqual('woodenPanel', item, value)

}
